<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-body p-2">
        <div class="row g-0 ps-2 mb-2" *ngFor="let item of RegimeDetails[0] | keyvalue">
            <div class="col-9">
                <span style="font-weight:400">
                    {{ item.key }}
                </span>
            </div>
            <div class="col-3 text-end">
                <span style="font-weight:400"><i class="bi bi-currency-rupee"></i>{{ item.value }}
                </span>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary mx-1" [disabled]="isDisabled" (click)="close()"><i
                        class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Close':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>